import React from "react";
import { FaBars } from "react-icons/fa/";
import { ThemeToggler } from "gatsby-plugin-dark-mode";
import { Popover } from "@headlessui/react";

import Logos from "./Logos";
import MenuBar from "./MenuBar";
import Navbar from "./Navbar";
import ThemeToggle from "./ThemeToggle";
import Footer from "./Footer";

const Header = ({ children, headerClassName = "" }) => {
  return (
    <header
      className={`sticky top-0 z-20 h-28 w-full bg-ensuperlig-1 ${headerClassName}`}
    >
      {children}
    </header>
  );
};

const Layout = ({ children }) => {
  return (
    <ThemeToggler>
      {({ theme, toggleTheme }) => (
        <Popover className="flex flex-col items-center w-full min-h-screen dark:bg-gray-900">
          {({ open, close }) => (
            <>
              <Header headerClassName="relative lg:shrink-0">
                <div className="lg:hidden">
                  <button className="absolute top-16 z-40 right-6">
                    <ThemeToggle theme={theme} toggleTheme={toggleTheme} />
                  </button>
                  <Logos className="dark:bg-ensuperlig-1" />
                  <Popover.Button>
                    <FaBars className="absolute right-6 top-4 w-7 h-7 text-white cursor-pointer" />
                  </Popover.Button>
                </div>
                <Navbar theme={theme} toggleTheme={toggleTheme} />
              </Header>
              {open ? (
                <Popover.Panel className="absolute z-5 w-full top-2 lg:hidden">
                  <MenuBar closeMenu={close} />
                </Popover.Panel>
              ) : (
                <>
                  <main className="lg:mt-8 lg:max-w-screen-2xl w-full flex flex-col lg:flex-row grow bg-white dark:bg-gray-900">
                    {children}
                  </main>
                  <Footer className="lg:flex" />
                </>
              )}
            </>
          )}
        </Popover>
      )}
    </ThemeToggler>
  );
};

export default Layout;
